
import { authRoutes } from './auth';
import { expressUiRoutes } from './expressUi';
import { healthCheck } from './health';

const routes = [
  ...authRoutes,
  ...expressUiRoutes,
  ...healthCheck,
];

export { routes };
